import { TLocale } from 'shared/domain/valueObjects';

export const COUNTRY_CODES: Record<TLocale, string> = {
  pt: '55',
  es: '595',
  'es-CR': '506',
  'es-UY': '598',
};
